import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { ActionFlag, BuilderMenu } from '@makyoapp/makyo-common'
import { Edit16, Trash16 } from '@makyoapp/makyo-icon/icon'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'

/**
 * MenuListItem is a function component that provides an interface for a single menu item in a builder.
 */
function MenuListItem({ menu }: { menu: BuilderMenu }) {
  const { t } = useTranslation()
  const { setMenuAction, deleteMenu } = useAppBuilderContext()

  const menuTitle = useVariableTextSingleCell(menu.title)

  // The menu item interface
  return (
    <div className={clsx('flex items-center', 'hover:bg-zinc-200 dark:hover:bg-slate-700 rounded-md')}>
      <div
        onClick={() => {
          // Set the menu action state to edit when the menu item is clicked
          setMenuAction({
            flag: ActionFlag.Edit,
            menu,
          })
        }}
        className={clsx('w-full px-2 h-10 txt flex-c')}
      >
        <MaterialIcon size={20} icon='menu' />
        <div className={clsx('txt')}>{menuTitle}</div>
      </div>
      {/* Edit and delete buttons */}
      <div className='shrink-0 flex items-center ltr:pr-2 rtl:pl-2'>
        <Button
          variant={ButtonVariant.Ghost}
          icon={<Edit16 />}
          noPadding
          squared
          title={t('Edit Menu')}
          onClick={() =>
            setMenuAction({
              flag: ActionFlag.Edit,
              menu,
            })
          }
          noTip
        />
        <Button
          variant={ButtonVariant.Ghost}
          icon={<Trash16 />}
          noPadding
          squared
          onClick={
            async () =>
              /*setMenuAction({
              flag: ActionFlag.Delete,
              menu
            })*/
              await deleteMenu(menu.id) // Delete the menu when the delete button is clicked
          }
          title={t('Delete Menu')}
          noTip
        />
      </div>
    </div>
  )
}

export default MenuListItem
